import { ChangeDetectionStrategy, Component, input, model } from '@angular/core'
import { IconUi } from '../icons/icon-ui'

@Component({
  selector: 'dropdown',
  imports: [IconUi],
  templateUrl: './dropdown.html',
  styleUrls: ['./dropdown.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Dropdown {
  id = input<string>('default')

  isOpen = model(false)
}
